"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-michele-di-serino": {
    "13886280": [{
      "hkey": "490043af",
      "slug": "san-michele-di-serino",
      "name": "San Michele di Serino",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-delle-grazie": [{
      "hkey": "490043af",
      "slug": "san-michele-di-serino",
      "name": "San Michele di Serino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;